import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../App';
import Navbar from '../components/Navbar';
import { toast } from 'sonner';

const AuthPage = () => {
  const [mode, setMode] = useState('login'); // login, register, phone
  const [formData, setFormData] = useState({ email: '', password: '', name: '', phone: '', code: '' });
  const [showOTP, setShowOTP] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { login, register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (mode === 'login') {
      const success = await login({ email: formData.email, password: formData.password });
      if (success) navigate('/admin/dashboard');
    } else if (mode === 'register') {
      const success = await register({ email: formData.email, password: formData.password, name: formData.name });
      if (success) navigate('/admin/dashboard');
    }
  };

  const handlePhoneOTP = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/phone/send-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: formData.phone })
      });
      
      if (response.ok) {
        setShowOTP(true);
        toast.success('OTP sent! Use code: 123456 (Mock)');
      }
    } catch (error) {
      toast.error('Failed to send OTP');
    }
  };

  const handleVerifyOTP = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/phone/verify-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ phone: formData.phone, code: formData.code, name: formData.name })
      });
      
      if (response.ok) {
        toast.success('Logged in successfully!');
        navigate('/admin/dashboard');
      } else {
        toast.error('Invalid OTP');
      }
    } catch (error) {
      toast.error('Verification failed');
    }
  };

  return (
    <div>
      <Navbar />
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, var(--secondary) 0%, white 100%)', paddingTop: '5rem' }}>
        <div className="card" style={{ maxWidth: '450px', width: '100%', margin: '2rem' }}>
          <h2 style={{ marginBottom: '2rem', textAlign: 'center' }}>
            {mode === 'login' ? 'Welcome Back' : mode === 'register' ? 'Create Account' : 'Phone Login'}
          </h2>

          {mode !== 'phone' ? (
            <form onSubmit={handleSubmit}>
              {mode === 'register' && (
                <div className="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    data-testid="name-input"
                  />
                </div>
              )}

              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  data-testid="email-input"
                />
              </div>

              <div className="form-group">
                <label>Password</label>
                <div style={{ position: 'relative' }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    required
                    data-testid="password-input"
                    style={{ paddingRight: '45px' }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '1.2rem',
                      color: 'var(--muted-foreground)',
                      padding: '5px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? '👁️' : '👁️‍🗨️'}
                  </button>
                </div>
              </div>

              <button type="submit" className="btn-primary" style={{ width: '100%' }} data-testid="submit-btn">
                {mode === 'login' ? 'Login' : 'Register'}
              </button>
            </form>
          ) : (
            <div>
              {!showOTP ? (
                <div>
                  <div className="form-group">
                    <label>Name</label>
                    <input
                      type="text"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Phone Number</label>
                    <input
                      type="tel"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      placeholder="+91XXXXXXXXXX"
                      required
                    />
                  </div>
                  <button onClick={handlePhoneOTP} className="btn-primary" style={{ width: '100%' }}>
                    Send OTP
                  </button>
                </div>
              ) : (
                <div>
                  <div className="form-group">
                    <label>Enter OTP</label>
                    <input
                      type="text"
                      value={formData.code}
                      onChange={(e) => setFormData({ ...formData, code: e.target.value })}
                      placeholder="123456"
                      required
                    />
                  </div>
                  <button onClick={handleVerifyOTP} className="btn-primary" style={{ width: '100%' }}>
                    Verify OTP
                  </button>
                </div>
              )}
            </div>
          )}

          <div style={{ marginTop: '2rem', textAlign: 'center' }}>
            {mode === 'login' ? (
              <>
                <p style={{ color: 'var(--muted-foreground)', marginBottom: '1rem' }}>Don't have an account? <button onClick={() => setMode('register')} style={{ color: 'var(--primary)', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}>Register</button></p>
                <p style={{ color: 'var(--muted-foreground)' }}>Or <button onClick={() => setMode('phone')} style={{ color: 'var(--primary)', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}>Login with Phone</button></p>
              </>
            ) : mode === 'register' ? (
              <p style={{ color: 'var(--muted-foreground)' }}>Already have an account? <button onClick={() => setMode('login')} style={{ color: 'var(--primary)', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}>Login</button></p>
            ) : (
              <p style={{ color: 'var(--muted-foreground)' }}>Or <button onClick={() => setMode('login')} style={{ color: 'var(--primary)', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}>Login with Email</button></p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;